import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskHasCarPartRepairRemoveService } from './remove.service';

@NgModule({
  imports: [CommonModule],
  providers: [TaskHasCarPartRepairRemoveService],
})
export class TaskHasCarPartRepairsModule {}
